import { Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { BreadcrumbItem } from '@gfe/shared/breadcrumb/breadcrumb.model';

@Component({
  selector: 'app-breadcrumb-item',
  imports: [RouterLink],
  templateUrl: './breadcrumb-item.component.html',
  styles: ``
})
export class BreadcrumbItemComponent {
  item = input.required<BreadcrumbItem>();
  isLast = input<boolean>(false);

  protected textClass = computed(() => {
    const cursor = this.item().link
      ? 'cursor-pointer'
      : 'pointer-events-none cursor-default';
    const color = this.isLast()
      ? 'text-text-primary font-semibold'
      : 'text-text-secondary font-medium';
    return `${cursor} ${color}`;
  });
}
